import { render } from "./BenefitAnggotaCard.vue?vue&type=template&id=96a9161a&scoped=true"
import script from "./BenefitAnggotaCard.vue?vue&type=script&lang=js"
export * from "./BenefitAnggotaCard.vue?vue&type=script&lang=js"

import "./BenefitAnggotaCard.vue?vue&type=style&index=0&id=96a9161a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96a9161a"]])

export default __exports__